import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "v2_ic_alert_yellow",
  "use": "v2_ic_alert_yellow-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\" id=\"v2_ic_alert_yellow\">\n    <g fill=\"none\" fill-rule=\"evenodd\">\n        <path d=\"M0 0h18v18H0z\" />\n        <path fill=\"#f9c927\" d=\"M8.625 1.125c-4.14 0-7.5 3.36-7.5 7.5 0 4.14 3.36 7.5 7.5 7.5 4.14 0 7.5-3.36 7.5-7.5 0-4.14-3.36-7.5-7.5-7.5zm.75 11.25h-1.5v-1.5h1.5v1.5zm0-3h-1.5v-4.5h1.5v4.5z\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol